// extracted by mini-css-extract-plugin
export default {"switch":"_1WEW_Q-8","switchHandle":"_3zWOGX1m","switchOn":"_3v_vY0QR"};